import cn from 'classnames';

import s from './Arrow.module.scss';

const Arrow = ({ className = '' }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      className={cn(s.root, className)}
    >
      <path d="M12 24H46.5" stroke="currentColor" strokeWidth="3" />
      <path
        d="M20.545 8.06592L4.61072 24.0001L20.545 39.9344"
        stroke="currentColor"
        strokeWidth="3"
      />
    </svg>
  );
};

export { Arrow };
